import { FC } from "react";
import { Control, useController } from "react-hook-form";
import { ErrorMessage } from "../ErrorMessage";
import "./style.css";

interface Props {
  name: string;
  label: string;
  control: Control<any>;
  type?: string;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
}

export const Input: FC<Props> = ({
  name,
  label,
  required,
  control,
  multiline,
  rows,
  type = "text",
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <label className="input-wrapper">
      <p>{label}</p>
      {multiline ? (
        <textarea rows={rows} {...field} />
      ) : (
        <input type={type} required={required} {...field} />
      )}
      {error && <ErrorMessage error={error?.message} />}
    </label>
  );
};
